import React from 'react'
import { useIntl } from 'react-intl'
import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core'
import CancelButton from 'app/components/buttons/CancelButton'
import DeleteButton from 'app/components/buttons/DeleteButton'
import useMobileStyle from 'app/components/mobileModal/mobileModalStyle'
import { Transition } from './TopicCardDialog'
import { makeStyles } from '@material-ui/core/styles'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import './styles/notification-topic-table.css'
import { useSelector } from 'react-redux'
import * as R from 'ramda'

const useStyles = makeStyles({
  deleteTopicDialog: {
    '& .MuiPaper-root': {
      width: '380px',
      padding: '10px 15px 15px 0',
    },
  },
})

export default (props) => {
  const { isOpen = false, onClose, onSubmit, classes, topicId } = props,
    { formatMessage } = useIntl()

  const { deleteDialogState } = useSelector((state) => state.topicReducer)

  const getButtonsStyle = (isOpenDeleteDialog) => {
    if (isOpenDeleteDialog) {
      return {
        width: '80px',
        height: '35px',
      }
    }
    return {
      height: '35px',
      padding: '0px 15px 0px 15px',
    }
  }

  const dialogTitle = formatMessage({
    id: 'notifications.topics.dialog.delete.title',
  })

  const deactivateButton = formatMessage({
    id: 'notifications.topic.deactivate.modal.button',
  })

  const description = (isOpenDeleteDialog) => {
    if (isOpenDeleteDialog) {
      return formatMessage({ id: 'notification.topics.dialog.description' })
    } else
      return formatMessage({
        id: 'notifications.topic.deactivate.modal.label',
      })
  }

  const deleteTopicDialog = useStyles()
  const mobileClasses = useMobileStyle()

  const handleClickDelete = () => {
    onSubmit(topicId)
    onClose()
  }

  return (
    <ResponsiveDialog
      fullScreen={false}
      onEscapeKeyDown={() => {
        onClose()
      }}
      open={isOpen}
      TransitionComponent={Transition}
      maxWidth="xs"
      className={deleteTopicDialog.deleteTopicDialog}
    >
      <DialogTitle id="alert-dialog-title" className={classes.groupDeleteTitle}>
        {dialogTitle}
      </DialogTitle>
      <DialogContent style={{ marginTop: '-10px' }}>
        <DialogContentText
          id="alert-dialog-description"
          style={{ color: 'black' }}
        >
          {description(R.prop('isOpenDeleteDialog', deleteDialogState))}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <CancelButton
          onClick={() => {
            onClose()
          }}
          className={mobileClasses.modalBtn}
          style={{
            width: '80px',
            height: '35px',
          }}
        />
        <DeleteButton
          onClick={handleClickDelete}
          msgId={
            R.prop('isOpenDeactivateDialog', deleteDialogState)
              ? deactivateButton
              : null
          }
          style={getButtonsStyle(
            R.prop('isOpenDeleteDialog', deleteDialogState),
          )}
        />
      </DialogActions>
    </ResponsiveDialog>
  )
}
